import React, { useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import Form from "react-bootstrap/Form";
import { FaEyeSlash, FaEye } from "react-icons/fa";

import "./PasswordInput.css";

export default function PasswordInput(props) {
  const [showPass, setShowPass] = useState(false);  

  return (
    <InputGroup
      className={`Password-input ${props.isInvalid && "is-invalid"} ${
        props.isValid && "is-valid"
      }`}
    >
      <Form.Control
        {...props}
        type={!showPass ? "password" : "text"}
        className="w-100"
      />
      <div className="show-icon">
        {showPass && <FaEyeSlash tabindex="0" aria-label="Hide Password" onClick={() => setShowPass(false)} onKeyPress={(e) => {if (e.key === 'Enter') setShowPass(false)}} />}
        {!showPass && <FaEye tabindex="0" aria-label="Show Password"  onClick={() => setShowPass(true)} onKeyPress={(e) => {if (e.key === 'Enter') setShowPass(true)}} />}
      </div>
    </InputGroup>
  );
}
